"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseQuiet = exports.parse = void 0;
const token_1 = require("../instruction/token");
const associated_token_account_1 = require("../instruction/associated-token-account");
const memo_1 = require("../instruction/memo");
const stake_1 = require("../instruction/stake");
const system_1 = require("../instruction/system");
const parse = (ix) => {
    if ("parsed" in ix) {
        const program = ix.program;
        switch (program) {
            case "system":
                return {
                    program,
                    title: "System",
                    instruction: (0, system_1.parseSystemInstruction)(Object.assign(Object.assign({}, ix), { program })),
                };
            case "spl-associated-token-account":
                return {
                    program,
                    title: "Associated Token Account",
                    instruction: (0, associated_token_account_1.parseAssociatedTokenAccountInstruction)(Object.assign(Object.assign({}, ix), { program })),
                };
            case "spl-memo":
                return {
                    program,
                    title: "Memo",
                    instruction: (0, memo_1.parseSplMemoInstruction)(Object.assign(Object.assign({}, ix), { program })),
                };
            case "stake":
                return {
                    program,
                    title: "Stake",
                    instruction: (0, stake_1.parseStakeInstruction)(Object.assign(Object.assign({}, ix), { program })),
                };
            case "spl-token":
                return {
                    program,
                    title: "Token",
                    instruction: (0, token_1.parseSplTokenInstruction)(Object.assign(Object.assign({}, ix), { program })),
                };
            default:
                return unknown();
        }
    }
    return unknown();
};
exports.parse = parse;
const parseQuiet = (ix) => {
    try {
        return (0, exports.parse)(ix);
    }
    catch (_) {
        return unknown();
    }
};
exports.parseQuiet = parseQuiet;
function unknown() {
    return {
        program: "unknown",
        title: "Unknown",
        instruction: undefined,
    };
}
//# sourceMappingURL=parser.js.map